<div *ngIf="type === 'success'">
  <h1 mat-dialog-title style="margin-left: 2%">New Patron Profile Created</h1>
  <div mat-dialog-content>
    <div class="container-fluid">
      <div class="row" *ngIf="patronDetails">
        <div class="col-12">
          <div>
            <strong>Library Card Number: {{ patronDetails?.libraryCardNumber }}</strong>
          </div>
          <div>
            <strong>Last Name: {{ patronDetails?.lastName }}</strong>
          </div>
          <div>
            <strong>User Name: {{ patronDetails?.userName }}</strong>
          </div>
          <div>
            <strong>Password: {{ patronDetails?.password }}</strong>
          </div>
          <div style="margin-bottom: 2%">
            <strong>Patron Id: {{ patronDetails?.patronId }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions style="margin-left: 2%">
    <button
      role="button"
      type="button"
      class="btn btn-primary"
      aria-label="OK"
      cdkFocusInitial
      (click)="okayClick()"
    >
      OK
    </button>
  </div>
</div>

<div *ngIf="type === 'fail'">
  <h1 mat-dialog-title style="margin-left: 2%">New Patron Profile Not Created</h1>
  <div mat-dialog-content>
    <div class="container-fluid">
      <div class="row" *ngIf="patronDetails">
        <div class="col-12" [innerHTML]="patronDetails"></div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions style="margin-left: 2%">
    <button
      role="button"
      type="button"
      class="btn btn-primary"
      aria-label="OK"
      cdkFocusInitial
      (click)="closeClick()"
    >
      Close
    </button>
  </div>
</div>
